import { Alert, Col, Container, Row } from "react-bootstrap";

//spotsync controls

//spotsync data
import { useRouteLoaderData, useNavigate } from "react-router-dom";
import { HeaderText } from "./Controls/HeaderText";
import { ConnectNotificationBanner, ConnectBalances, ConnectAccountManagement, ConnectAccountOnboarding } from "@stripe/react-connect-js";
import { ExtendedFacility } from ".";
import { PageTitle } from "./Controls/PageTitle";
import { authAtom } from "./Data/Atoms";
import { getDefaultStore } from "jotai";
import { RoleList } from "./helpers/RoleManager";   
import { Button } from "./Controls/Button";

export function FacilityOnboardingPage() {    
    const facility = useRouteLoaderData( "facilityReport" ) as ExtendedFacility;
    const acct     = facility.account;
    const defaultStore = getDefaultStore();
    const auth = defaultStore.get(authAtom);
    const nav = useNavigate();
    return <Container fluid>
        
        <Row>
            <Col>
                <PageTitle>
                    Overview
                </PageTitle>
            </Col>
        </Row>
        {auth.account?.roles.includes(RoleList.SuperAdmin.name) && !acct.isOnboarded && 
        <Row>
            <Col>
                <Alert variant="warning">   
                    You have not completed onboarding. Go to the "Listing" page to complete onboarding.<br />
                    <Button className="mt-2 btn-main" onClick={() => nav(`/facility/${facility.facilityId}/listing`)}>Go to Listing</Button>
                </Alert>
            </Col>
        </Row>}
        <Row>
            <Col>
                <ConnectAccountOnboarding
                    onExit={() => {
                        console.log( "The account has exited onboarding" );
                    }}>
                </ConnectAccountOnboarding>
            </Col>
        </Row>
        <Row>
            <Col>{acct.isOnboarded && <ConnectAccountManagement />}</Col>
        </Row>
        
        {!auth.account?.roles.includes(RoleList.SuperAdmin.name) && !acct.isOnboarded && <Row>
            <Col>
                <Alert variant="info" className="mt-2 alert-light-bg">
                    <b>Your bank account has not been configured and is required for parking payments.</b><br /> Please contact SpotSync support to complete your onboarding.
                </Alert>
            </Col>
        </Row>}
        <Row>
            <Col xs="12" md="12">
                <ConnectNotificationBanner collectionOptions={{ fields: "eventually_due", futureRequirements: "include" }} />
                <br />
            </Col>
        </Row>
        <Row>
            <Col xs="12" md="12">
                <HeaderText>Balance</HeaderText>
                <ConnectBalances />
                <br />
            </Col>
        </Row>        
    </Container>;
}
